module.exports = __webpack_public_path__ + "img/bg_age_1.dd3ad70b.png";